__turbopack_context__.v({
  "answer": "Faq-module-scss-module__66YY9a__answer",
  "arrowIcon": "Faq-module-scss-module__66YY9a__arrowIcon",
  "icon": "Faq-module-scss-module__66YY9a__icon",
  "question": "Faq-module-scss-module__66YY9a__question",
  "titleWrapper": "Faq-module-scss-module__66YY9a__titleWrapper",
  "wrapper": "Faq-module-scss-module__66YY9a__wrapper",
});
